const DEV = {
    // ADMIN_URL: 'http://192.168.10.7:18601',
    // ADMIN_URL: 'http://192.168.10.202:8091/portal',
    // ADMIN_URL: 'http://192.168.3.162:11601/portal',  //测试 
    // ADMIN_URL: 'http://192.168.3.162:14000/portal',  //测试 
    // ADMIN_URL: 'http://192.168.3.16:18603',  //荣俊 (temp)
    // ADMIN_URL: 'http://192.168.3.16:18601',  //荣俊
    // ADMIN_URL: 'http://192.168.3.16:18602',  //荣俊
    // ADMIN_URL: 'http://192.168.3.10:16000/portal',  //老褚
    // ADMIN_URL: 'http://192.168.3.10:2600/portal',  //老褚
    // ADMIN_URL: 'http://192.168.3.10:1600/portal',  //老褚 (temp)
    // ADMIN_URL: 'http://192.168.3.14:17001/portal/',  //姜涛
    // ADMIN_URL: 'http://192.168.10.17:3000/saml',  
    ADMIN_URL: 'http://192.168.3.18:18601/portal',  //柯晨
    SAML_URL: '/saml',
    LOGOUT_URL: './#/login',
};

const TEST = {
    ADMIN_URL: 'http://192.168.10.126:8501/portal',
    SAML_URL: '/saml',
    LOGOUT_URL: './',
};

const LOC = {
    ADMIN_URL: 'http://localhost:12888/portal',
    SAML_URL: '/front',
    LOGOUT_URL: './#/login',
    MAP_KEY: 'acfe339236c6150eb8e5582f5362843d',
    MAP_URL: 'http://localhost:4000',
    MAP_Service_URL: 'http://192.168.10.160:8091/portal'
};

const PRODUCTION = {
    ADMIN_URL: 'http://101.37.16.69:13000/portal',
    SAML_URL: '/front',
    LOGOUT_URL: './',
};

const CONFIG = window.configs;



// export let ENV = DEV;
// export let ENV = TEST;
// export const ENV = PRODUCTION;

const ENV = CONFIG;
// const ENV = DEV;


export {ENV as default};



// WEBPACK FOOTER //
// ./src/common/env.js